import { useMemo } from "react";
import qrcode from "qrcode-generator";

/**
 * O QR code da `otpauth://` que o aplicativo autenticador lê.
 *
 * Gerado AQUI, no navegador: o segredo nunca vai a um serviço de QR de terceiros. O SVG sai da
 * biblioteca (só `<rect>`/`<path>` de formas, sem texto da pessoa), por isso entra como HTML.
 */
export function QrDoSegredo({ uri }: { uri: string }) {
  const svg = useMemo(() => {
    const codigo = qrcode(0, "M");
    codigo.addData(uri);
    codigo.make();
    return codigo.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
  }, [uri]);

  return (
    <div
      className="qr-do-segredo"
      role="img"
      aria-label="QR code para o aplicativo autenticador"
      data-testid="qr-do-segredo"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
